module.exports = __webpack_public_path__ + "static/media/S1_00011.378d978a.jpg";